export class ExportCategory {
    id: string;
    title: string; 
    checked: Boolean;
    constructor (data) {
        this.id = data.id;
        this.title = data.title; 
        this.checked = data.checked;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/category/export-category.ts